export default "__VITE_ASSET__UFTg62GJ__"